import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "button"]

  check() {
    const match = this.inputTarget.value.trim() === "CORRECT"
    this.buttonTarget.disabled = !match
  }
}
